import { Chart } from './Chart'
import { Impact } from './Impact'
import styles from './Charts.module.scss'
import { useAppContext } from './../../hooks/useAppContext'
import { NumericFormat } from 'react-number-format'

export const Charts = () => {
    const { monthsForChart, chartsValues } = useAppContext()
    const [{ revenueDiff }] = chartsValues.slice(-1)
    return (
        <section className={styles.section}>
            <h1>You could generate
                <NumericFormat
                value={revenueDiff} displayType={'text'} thousandSeparator={true} prefix={'$'}
                    renderText={(value) => <span className={revenueDiff > 0 ? styles.profit : styles.less}>{' '}{`${value}`}</span>} />
                {revenueDiff < 0 ? <span className={styles.less}> less </span> : <span className={styles.profit}> more </span>}
                revenue in {monthsForChart} months</h1>
            <div className={styles.chart_containier}>
                <Chart />
                <Impact />
            </div>
        </section>
    )
}
